<script setup>
import { ref } from 'vue'
import moment from 'moment/moment'
import QuestionGroupComponent from '@/components/CompiledPoll/QuestionGroupComponent.vue'

defineProps(['handleAnswer', 'compiledPoll', 'form'])
const confirmSend = ref(false)

function formatDate(date) {
  moment.locale('it')
  date = new Date(date)
  date = moment(date).format('L')
  return date
}
</script>

<template>
  <div class="card poll-component mb-0 border-0 shadow-none" v-if="compiledPoll['poll']">
    <div class="card-header d-flex justify-content-between">
      <span>{{ compiledPoll['poll'].title }}</span>
    </div>
    <div class="card-body">
      <h5 v-if="compiledPoll['state'] === 'filled'">
        Compilato il: {{ formatDate(compiledPoll['filledDate']) }}
      </h5>
      <div class="alert alert-danger me-3 d-none form-errors">
        Errore nella compilazione del questionario, controlla i dati e riprova
      </div>
      <div
        :id="questionGroup.id"
        v-for="questionGroup in compiledPoll['poll']['questionGroups']"
        :key="questionGroup.id"
      >
        <question-group-component
          :compiled-poll="compiledPoll"
          :handle-answer="handleAnswer"
          :question-group="questionGroup"
        ></question-group-component>
      </div>

    </div>

    <div :class="'modal ' + (confirmSend ? 'd-block' : '')" tabindex="-1">
      <div class="backdrop">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Conferma invio</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="confirmSend = false"
              ></button>
            </div>
            <div class="modal-body">
              <p>
                Una volta inviato il questionario non potrà essere più
                modificato/rinviato.
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                @click="confirmSend = false"
              >
                Annulla
              </button>
              <button type="button" class="btn btn-primary" @click="sendFilled">
                Invia
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
